import { render, staticRenderFns } from "./SectionItemCreate.vue?vue&type=template&id=46156594&scoped=true&"
import script from "./SectionItemCreate.vue?vue&type=script&lang=js&"
export * from "./SectionItemCreate.vue?vue&type=script&lang=js&"
import style0 from "./SectionItemCreate.vue?vue&type=style&index=0&id=46156594&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46156594",
  null
  
)

export default component.exports